import { render, staticRenderFns } from "./CoachDetailDanceKinds.vue?vue&type=template&id=79c54422&scoped=true&lang=pug"
import script from "./CoachDetailDanceKinds.vue?vue&type=script&lang=js"
export * from "./CoachDetailDanceKinds.vue?vue&type=script&lang=js"
import style0 from "./CoachDetailDanceKinds.vue?vue&type=style&index=0&id=79c54422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c54422",
  null
  
)

export default component.exports